export default {
    createNewVisitor: 'สร้างผู้เยี่ยมชม',
    updateVisitor: 'แก้ไขข้อมูลผู้เยี่ยมชม',
    accessInformation: 'ข้อมูลการเข้าออก',
    change: 'เปลี่ยน',
    msgImageSize: 'ขนาดรูปภาพต้องอยู่ระหว่าง 25kb ถึง 200kb',
    msgErrorImageSize: 'ขนาดของรูปภาพต้องอยู่ระหว่าง 25KB เเละ 200KB',
    cancel: 'ยกเลิก',
    save: 'บันทึก',
    name: 'ชื่อ',
    surname: 'นามสกุล',
    profile: 'ข้อมูลส่วนตัว',
    citizenId: 'บัตรประชาชน/หนังสือเดินทาง',
    gender: 'เพศ',
    male: 'ชาย',
    female: 'หญิง',
    email: 'อีเมล์',
    phoneNumber: 'เบอร์โทร',
    statusStart: 'วันที่เริ่มต้น',
    statusEnd: 'วันที่สิ้นสุด',
    timeStart: 'เริ่มเวลา',
    timeEnd: 'สิ้นสุดเวลา',
    active: 'ใช้งาน',
    deactive: 'ปิดการใช้งาน',
    msgError: 'เกิดข้อผิดพลาด',
    congratulation: 'ยินดีด้วย',
    warning: 'เเจ้งเตือน',
    error: 'ข้อผิดพลาด',
    endDateIsPassed: 'วันสิ้นสุดผ่านไปเเล้ว',
    msgRequiredField: 'กรุณากรอกข้อมูล',
    msgExceededField: 'ข้อความเกิน 255 ตัวอักษร',
    msgRequiredEmail: 'กรุณากรอกอีเมล์',
    msgInvalidEmailFormat: 'รูปเเบบอีเมล์ไม่ถูกต้อง',
    msgExceededEmail: 'อีเมล์เกิน 255 ตัวอักษร',
    cardNo: 'หมายเลขบัตร',
    msgExceededCardNo: 'หมายเลขบัตรเกิน 10 ตัวอักษร',
    msgImageSizeZkt: 'ขนาดรูปภาพต้องอยู่ระหว่าง 50KB ถึง 400KB',
    msgErrorImageSizeZkt: 'ขนาดของรูปภาพต้องอยู่ระหว่าง 50KB เเละ 400KB'
}
